module.exports = __webpack_public_path__ + "img/kirim_uang.81e3dee8.png";